import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
import type { Job } from "~/types/job";
import { PrintviewHeader } from "../printview-default/printview-header-eon";
import { PrintviewDetailsBoxEonUk } from "./printview-details-box-eon-uk";
import { PrintviewJobadEonUk } from "./printview-jobad-eon-uk";
export default function PrintViewEonUk(t0) {
  const $ = _c(9);
  const {
    job
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("page", "hidden w-full border-collapse text-black text-sm print:block", "print-color-adjust-exact", "box-decoration-break-clone");
    t2 = {
      printColorAdjust: "exact",
      boxDecorationBreak: "clone"
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== job) {
    t3 = <PrintviewHeader job={job} />;
    $[2] = job;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== job) {
    t4 = <tbody className="reportcontent"><tr><td><div className="grid h-min grid-flow-col grid-cols-8 gap-6"><PrintviewDetailsBoxEonUk job={job} /><PrintviewJobadEonUk job={job} /></div></td></tr></tbody>;
    $[4] = job;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <table className={t1} style={t2}>{t3}{t4}</table>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}